import React, { Component } from 'react';
import ClockInClockOutScreenComponent from '../../../component/TimeTrackerModuleComponent/ClockInClockOutScreenComponent/ClockInClockOutScreenComponent';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/actions/index';
import { tzUTCDateTimeConverterTool_V1 } from '../../../../utility/TimezoneOperations/timezoneUtility';
import storage from '../../../../utility/storage';
import { routes } from '../../../../utility/constants/constants';
const cloneDeep = require('clone-deep');
var momentTZ = require('moment-timezone');

class ClockInClockOutScreenContainer extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {

        let isClockInEngaged = storage.get('isClockInEngaged') ? storage.get('isClockInEngaged') : false;

        if (isClockInEngaged == true) {
            this.props.flUserShiftClockChecker({ data: { current_time: tzUTCDateTimeConverterTool_V1(momentTZ().format('YYYY-MM-DDTHH:mm:ss').split('T')[0], momentTZ().format('YYYY-MM-DDTHH:mm:ss').split('T')[1], 'none') } });
        }

    }

    componentWillUnmount() {
        this.props.resetTimeTrackerObjects();
    }

    handleShiftClockChecker = () => {
        let setData = { data: {} };

        let fetchedCurrDateTime = momentTZ(new Date()).format('MM-DD-YYYYTHH:mm:ss').split('T');
        let currentTime = tzUTCDateTimeConverterTool_V1(fetchedCurrDateTime[0], fetchedCurrDateTime[1], 'none');

        setData.data.current_time = currentTime;
        this.props.flUserShiftClockChecker(setData);
    }

    handleShiftClockCheckIn = () => {
        let setData = { data: { addresses_attributes: {} } };

        let fetchedCurrDateTime = momentTZ(new Date()).format('MM-DD-YYYYTHH:mm:ss').split('T');
        let checkInTime = tzUTCDateTimeConverterTool_V1(fetchedCurrDateTime[0], fetchedCurrDateTime[1], 'none');

        setData.data.check_int_at = checkInTime;

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setData.data.addresses_attributes.latitude = latitude;
                    setData.data.addresses_attributes.longitude = longitude;
                    this.props.flUserShiftClockCheckIn(setData);
                },
                (error) => {
                    console.error('Error getting location:', error.message);
                }
            );
        }
    }

    handleShiftMealBreakCheckIn = (dateObject, id) => {
        let setData = { data: {} };
        let start, end = null

        let fetchedCurrDateTime = momentTZ(new Date()).format('MM-DD-YYYYTHH:mm:ss').split('T');

        if (dateObject && dateObject.start == null) {
            start = tzUTCDateTimeConverterTool_V1(fetchedCurrDateTime[0], fetchedCurrDateTime[1], 'none');
            setData.data.start = start;
        } else {
            end = tzUTCDateTimeConverterTool_V1(fetchedCurrDateTime[0], fetchedCurrDateTime[1], 'none');
            setData.data.end = end;
        }

        this.props.flUserMealBreakSession(setData, id);
    }

    handleMyShiftClick = () => {
        this.props.history.push(`/shift-schedule/preview-shift-schedule/${this.props.clockedInShiftData.id}`);
    }

    handleMyTicketsClick = () => {
        this.props.history.push(routes.FLUSER_MYTICKET);
    }

    render() {
        return (
            <>

                <ClockInClockOutScreenComponent
                    {...this.props}
                    handleShiftClockChecker={this.handleShiftClockChecker}
                    handleShiftClockCheckIn={this.handleShiftClockCheckIn}
                    handleShiftMealBreakCheckIn={this.handleShiftMealBreakCheckIn}
                    handleMyShiftClick={this.handleMyShiftClick}
                    handleMyTicketsClick={this.handleMyTicketsClick}
                />

            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
        isLoading: state.TimeTrackerModReducer.isLoading,
        isMealPenaltyLoader: state.TimeTrackerModReducer.isMealPenaltyLoader,
        isClockInShiftAvailable: state.TimeTrackerModReducer.isClockInShiftAvailable,
        clockedInShiftData: state.TimeTrackerModReducer.clockedInShiftData,
        clockInCheckedInTime: state.TimeTrackerModReducer.clockInCheckedInTime, // Checked In Time
        isShiftMealBreakTriggered: state.TimeTrackerModReducer.isShiftMealBreakTriggered,
        shiftMealBreakInfo: state.TimeTrackerModReducer.shiftMealBreakInfo,
        isTimeTrackerModalOpen: state.TimeTrackerModReducer.isTimeTrackerModalOpen,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetTimeTrackerObjects: () => dispatch(actions.resetTimeTrackerObjects()),
        flUserShiftClockChecker: (data) => dispatch(actions.flUserShiftClockChecker(data)),
        flUserShiftClockCheckIn: (data) => dispatch(actions.flUserShiftClockCheckIn(data)),
        flUserMealBreakSession: (body, id) => dispatch(actions.flUserMealBreakSession(body, id)),
        getMissedMealPenaltyBreaks: (shiftDetailId, currentTime, clockInData) => dispatch(actions.getMissedMealPenaltyBreaks(shiftDetailId, currentTime, clockInData)),

        handleFrequentTimeTracker_openModal: (data) => dispatch(actions.handleFrequentTimeTracker_openModal(data)),
        handleFrequentTimeTracker_closeModal: (data) => dispatch(actions.handleFrequentTimeTracker_closeModal(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClockInClockOutScreenContainer);